<template>
  <oie-header-state-message v-if="clientModel.enableMyMachines && (globalMachine || globalMachineOwner)" color="green" @click="removeGlobalMyMachinesSelection">
    <template #message>
      {{ message }}
    </template>
    <template #button-text>
      {{ tStatic('removeGlobalSelection') }}
    </template>
  </oie-header-state-message>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('myMachines', ['globalMachine', 'globalMachineOwner', 'machineOwnerDictionary', 'machineDictionary', 'readableGlobalSelection']),
    message() {
      if(this.globalMachine || this.globalMachineOwner) {
        return `${this.tStatic('shoppingFor')} ${this.readableGlobalSelection}`
      }
      return ''
    }
  },
  methods: {
    ...mapActions('myMachines', ['setGlobalMyMachinesSelection']),
    removeGlobalMyMachinesSelection() {
      this.setGlobalMyMachinesSelection({})
    }
  }
}
</script>

<style>

</style>
